document.addEventListener('DOMContentLoaded', function () {
    const editMyPagesMarker = document.getElementById('edit-mypages-form');
    if (!editMyPagesMarker) return;

    // @ts-ignore
    $('#edit-mypages-form').validate({
        onkeyup: false,
        errorClass: 'invalid',
        validClass: 'success',
        focusInvalid: false,
        rules: {
            careof: {
                required: false,
                minlength: 2
            },
            address: {
                required: true,
                minlength: 2
            },
            zipcode: {
                required: true,
            },
            city: {
                required: true,
                minlength: 2
            },
            phonenumber: {
                required: false,
            },
            mobilephone: {
                required: true,
                saMobil: true
            },
            email: {
                required: true,
                customemail: true
            }
        },
        messages: {
            careof: {
                minlength: 'Ange minst 2 tecken'
            },
            address: {
                required: 'Ange gatuadress',
                minlength: 'Ange minst 2 tecken'
            },
            zipcode: {
                required: 'Ange postnummer'
            },
            city: {
                required: 'Ange ort',
                minlength: 'Ange minst 2 tecken'
            },
            phonenumber: {
                nhas: 'Ange telefonnummer inklusive riktnummer'
            },
            mobilephone: {
                required: 'Ange mobiltelefonnummer',
                saMobil: 'Ange ett giltigt svenskt eller utl�ndskt telefonnummer'
            },
            email: {
                required: 'Ange e-postadress'
            }
        },
        invalidHandler: function (form, validator) {
            var errors = validator.numberOfInvalids();
            if (errors) {
                // @ts-ignore
                var firstErrorElement = $(validator.errorList[0].element);
                // @ts-ignore
                $('html, body').animate({
                    scrollTop: firstErrorElement.offset().top - 40
                });

                firstErrorElement.focus();
            }
        },
        success: function (label) {
            label.addClass('success');
        },
        submitHandler: function (form) {
            form.submit();
        }
    });
});
